import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment } from "vue";
const _hoisted_1 = {
  key: 1
};
const _hoisted_2 = {
  class: "flex justify-between"
};
const _hoisted_3 = {
  class: "flex justify-end"
};
const _hoisted_4 = {
  class: "flex pr-4 mt-2 at-enable-disable-rate-group"
};
const _hoisted_5 = {
  key: 0
};
const _hoisted_6 = {
  key: 1
};
const _hoisted_7 = {
  key: 0,
  class: "menu"
};
import MainHeader from "@/components/MainHeader.vue";
import Loader from "@/components/Loader.vue";
import LlSecondaryButton from "@/components/LlSecondaryButton.vue";
import LlSwitch from "@/components/LlSwitch.vue";
import UpdateRateGroupModal from "./UpdateRateGroupModal.vue";
import RateCard from "./RateCard.vue";
import { reactive, onMounted } from "vue";
import { useRateGroupStore } from "@/services/useRateGroupStore.js";
import { useMeStore } from "@/services/UserService/useMeStore";
import RateGroupActionMenu from "./RateGroupActionMenu.vue";
export default {
  __name: 'RateGroupMainPage',
  props: {
    alerts: {
      type: Object,
      required: true
    },
    modalService: {
      type: Object,
      required: true
    }
  },
  setup(__props) {
    const props = __props;
    const rateGroupState = reactive({
      loading: false,
      default: false,
      rateGroupList: [],
      openEditRateGroupModal: false,
      rateGroupAccounts: [],
      openRateGroupActionMenu: false,
      openRateGroupActionMenuIndex: null,
      rateGroupId: null,
      enabled: false,
      me: {}
    });
    const meStore = useMeStore();
    const rateGroupStore = useRateGroupStore();
    rateGroupStore.alerts = props.alerts;
    rateGroupStore.$subscribe((mutation, storeState) => {
      rateGroupState.rateGroupList = storeState.rateGroupList;
    });
    onMounted(async () => {
      rateGroupState.loading = true;
      rateGroupState.rateGroupList = await rateGroupStore.listRateGroup();
      rateGroupState.me = await meStore.getMe();
      rateGroupState.enabled = rateGroupState.me.company.settings.isRateGroupEnabled || false;
      await getRateGroupList();
      rateGroupState.loading = false;
      document.addEventListener("click", handleClickOutside);
    });
    const createRateGroup = (rateGroupId = null) => {
      if (rateGroupId === null) {
        rateGroupState.openEditRateGroupModal = true;
      }
    };
    const editRateGroup = async rateGroup => {
      const editRateGroupData = await rateGroupStore.getRateGroup(rateGroup.rateGroupId);
      rateGroupState.openEditRateGroupModal = true;
      rateGroupState.rateGroupId = editRateGroupData.rateGroupId;
      rateGroupState.name = editRateGroupData.name;
      rateGroupState.description = editRateGroupData.description;
      rateGroupState.default = editRateGroupData.default;
      rateGroupState.rateGroupAccounts = editRateGroupData.rateGroupAccounts;
    };
    const rateCardButtonMenuClicked = (rateGroup, index) => {
      if (rateGroupState.openRateGroupActionMenuIndex === index) {
        // If the same rate card is clicked again, toggle the action menu
        rateGroupState.openRateGroupActionMenuIndex = null;
      } else {
        // If a different rate card is clicked, open its action menu
        rateGroupState.openRateGroupActionMenuIndex = index;
      }
    };
    const handleClickOutside = event => {
      const actionMenuContainer = document.querySelector(".menu");
      if (!actionMenuContainer || actionMenuContainer.contains(event.target)) {
        // Click was inside the action menu container, do nothing
        return;
      }
      // Click was outside the action menu, close it
      rateGroupState.openRateGroupActionMenuIndex = null;
    };
    const rateGroupActionMenuClicked = async ($event, rateGroup) => {
      rateGroupState.openRateGroupActionMenuIndex = null;
      if ($event === "delete") {
        // Check if rate group is in use
        // if its in use, show error message
        if (rateGroup?.mattersCount > 0) {
          props.alerts.error("Cannot delete a rate group while it's in use.");
          return;
        }
        rateGroupStore.deleteRateGroup(rateGroup.rateGroupId);
      } else if ($event === "edit") {
        editRateGroup(rateGroup);
      } else if ($event === "duplicate") {
        await rateGroupStore.duplicateRateGroup(rateGroup.rateGroupId);
      } else if ($event === "setDefault") {
        const defaultParams = {
          default: true
        };
        await rateGroupStore.updateRateGroup(rateGroup.rateGroupId, defaultParams);
        rateGroupState.rateGroupList = rateGroupState.rateGroupList.map(item => {
          if (item.rateGroupId === rateGroup.rateGroupId) {
            item.default = true;
          } else {
            item.default = false;
          }
          return item;
        });
      }
    };
    const getRateGroupList = async () => {
      rateGroupState.rateGroupList = await rateGroupStore.listRateGroup();
    };
    const rateGroupStatusToggle = () => {
      if (rateGroupState.enabled) {
        props.alerts.error("Once Rate Group is enabled, it cannot be disabled.");
        return;
      }
      rateGroupStore.rateGroupStatusToggle().then(async response => {
        if (response) {
          await getRateGroupList();
          rateGroupState.enabled = !rateGroupState.enabled;
        }
      });
    };
    const updateRateGroupCard = async () => {
      rateGroupState.openEditRateGroupModal = false;
      await getRateGroupList();
    };
    return (_ctx, _cache) => {
      return rateGroupState.loading ? (_openBlock(), _createBlock(Loader, {
        key: 0,
        what: 'Rate Group',
        class: "mt-32"
      })) : (_openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(MainHeader, {
        content: 'Rate Group'
      }), _createElementVNode("div", _hoisted_3, [_withDirectives(_createElementVNode("div", _hoisted_4, [_createVNode(LlSwitch, {
        "model-value": rateGroupState.enabled,
        label: rateGroupState.enabled ? 'Enabled' : 'Disabled',
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => rateGroupStatusToggle())
      }, null, 8, ["model-value", "label"])], 512), [[_vShow, !rateGroupState.enabled]]), _createVNode(LlSecondaryButton, {
        id: "new-rate-group",
        color: "primary",
        disabled: !rateGroupState.enabled,
        onClick: _cache[1] || (_cache[1] = $event => createRateGroup())
      }, {
        default: _withCtx(() => [...(_cache[2] || (_cache[2] = [_createTextVNode(" New Rate Group ", -1)]))]),
        _: 1
      }, 8, ["disabled"])])]), !rateGroupState?.rateGroupList?.length ? (_openBlock(), _createElementBlock("div", _hoisted_5, [...(_cache[3] || (_cache[3] = [_createElementVNode("p", {
        class: "px-6"
      }, "There are no rate groups. Please add one.", -1)]))])) : (_openBlock(), _createElementBlock("div", _hoisted_6, [...(_cache[4] || (_cache[4] = [_createElementVNode("p", {
        class: "px-6"
      }, "Select any rate group to edit details", -1)]))])), rateGroupState.openEditRateGroupModal ? (_openBlock(), _createBlock(UpdateRateGroupModal, {
        key: 2,
        rateGroupState: rateGroupState,
        alerts: __props.alerts,
        modalService: __props.modalService,
        onRateGroupUpdated: updateRateGroupCard
      }, null, 8, ["rateGroupState", "alerts", "modalService"])) : _createCommentVNode("", true), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(rateGroupState.rateGroupList, (rateGroup, index) => {
        return _openBlock(), _createElementBlock("div", {
          class: "px-6 py-2",
          id: "rate-group-card",
          key: rateGroup.id
        }, [_createVNode(RateCard, {
          rateGroup: rateGroup,
          onOpenMenu: $event => rateCardButtonMenuClicked(rateGroup, index),
          onClick: $event => editRateGroup(rateGroup)
        }, null, 8, ["rateGroup", "onOpenMenu", "onClick"]), rateGroupState.openRateGroupActionMenuIndex === index ? (_openBlock(), _createElementBlock("div", _hoisted_7, [_createVNode(RateGroupActionMenu, {
          rateGroup: rateGroup,
          onMenuButton: rateGroupActionMenuClicked
        }, null, 8, ["rateGroup"])])) : _createCommentVNode("", true)]);
      }), 128))]));
    };
  }
};